var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToilet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 22,
    viewBox: "0 0 66 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 22,
    fill: "#A098AE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2868_1147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.572 6.636V7.524H18.292V15H17.2V7.524H14.908V6.636H20.572ZM25.7082 15.084C24.9322 15.084 24.2242 14.904 23.5842 14.544C22.9442 14.176 22.4362 13.668 22.0602 13.02C21.6922 12.364 21.5082 11.628 21.5082 10.812C21.5082 9.996 21.6922 9.264 22.0602 8.616C22.4362 7.96 22.9442 7.452 23.5842 7.092C24.2242 6.724 24.9322 6.54 25.7082 6.54C26.4922 6.54 27.2042 6.724 27.8442 7.092C28.4842 7.452 28.9882 7.956 29.3562 8.604C29.7242 9.252 29.9082 9.988 29.9082 10.812C29.9082 11.636 29.7242 12.372 29.3562 13.02C28.9882 13.668 28.4842 14.176 27.8442 14.544C27.2042 14.904 26.4922 15.084 25.7082 15.084ZM25.7082 14.136C26.2922 14.136 26.8162 14 27.2802 13.728C27.7522 13.456 28.1202 13.068 28.3842 12.564C28.6562 12.06 28.7922 11.476 28.7922 10.812C28.7922 10.14 28.6562 9.556 28.3842 9.06C28.1202 8.556 27.7562 8.168 27.2922 7.896C26.8282 7.624 26.3002 7.488 25.7082 7.488C25.1162 7.488 24.5882 7.624 24.1242 7.896C23.6602 8.168 23.2922 8.556 23.0202 9.06C22.7562 9.556 22.6242 10.14 22.6242 10.812C22.6242 11.476 22.7562 12.06 23.0202 12.564C23.2922 13.068 23.6602 13.456 24.1242 13.728C24.5962 14 25.1242 14.136 25.7082 14.136ZM32.4418 6.636V15H31.3498V6.636H32.4418ZM35.3949 14.112H38.3229V15H34.3029V6.636H35.3949V14.112ZM40.5746 7.524V10.32H43.6226V11.22H40.5746V14.1H43.9826V15H39.4826V6.624H43.9826V7.524H40.5746ZM50.7829 6.636V7.524H48.5029V15H47.4109V7.524H45.1189V6.636H50.7829Z",
    fill: "#F7F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2868_1147",
    x: 10.908,
    y: 3.53906,
    width: 43.875,
    height: 16.5449,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2868_1147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2868_1147",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToilet);
export default __webpack_public_path__ + "static/media/toilet.d4d393b4766d52bc86947b8c09940159.svg";
export { ForwardRef as ReactComponent };